import { HeadAccountCgtSettingsClient } from "../../../../../../Wrap/Api/Tax/HeadAccountCgtSettings";
import { HeadAccountCgtSettings } from "../../../../../../Wrap/Models/Domains/Tax/HeadAccountCgtSettings";

export class CGTAction {
    public static getCGTSettings(hierarchyId: string, callback) {
        const client = new HeadAccountCgtSettingsClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static postCGTSettings(settings: HeadAccountCgtSettings, callback) {
        const client = new HeadAccountCgtSettingsClient();
        const promise = client.post(settings);
        promise.onSuccess((result) => {
            callback(result);
        });
    }
}
